import { TestimonialVideo } from './types';

const toveLucasThumbnail = require('assets/images/marketplace/video-thumbnails/Tove-Lucas.jpg');
const fabianThumbnail = require('assets/images/marketplace/video-thumbnails/Fabian.png');
const friscoThumbnail = require('assets/images/marketplace/video-thumbnails/Frisco.png');
const ornellaThumbnail = require('assets/images/marketplace/video-thumbnails/Ornella.png');
const sahinThumbnail = require('assets/images/marketplace/video-thumbnails/Sahin.png');
const dogukanThumbnail = require('assets/images/marketplace/video-thumbnails/Dogukan.png');

export const testimonialsData: TestimonialVideo[] = [
  {
    id: '1',
    videoUrl: 'https://colochousing-production.s3.eu-west-1.amazonaws.com/Tove+%26+Lucas.mp4',
    thumbnailUrl: toveLucasThumbnail,
    title: 'js.features.marketplace.home.what_our_housemates_say_section.testimonials.tove_lucas'
  },
  {
    id: '2',
    videoUrl: 'https://colochousing-production.s3.eu-west-1.amazonaws.com/Fabien.mp4',
    thumbnailUrl: fabianThumbnail,
    title: 'js.features.marketplace.home.what_our_housemates_say_section.testimonials.fabian'
  },
  {
    id: '3',
    videoUrl: 'https://colochousing-production.s3.eu-west-1.amazonaws.com/Friso.mp4',
    thumbnailUrl: friscoThumbnail,
    title: 'js.features.marketplace.home.what_our_housemates_say_section.testimonials.friso'
  },
  {
    id: '4',
    videoUrl: 'https://colochousing-production.s3.eu-west-1.amazonaws.com/Ornella.mp4',
    thumbnailUrl: ornellaThumbnail,
    title: 'js.features.marketplace.home.what_our_housemates_say_section.testimonials.ornella'
  },
  {
    id: '5',
    videoUrl: 'https://colochousing-production.s3.eu-west-1.amazonaws.com/Sahin.mp4',
    thumbnailUrl: sahinThumbnail,
    title: 'js.features.marketplace.home.what_our_housemates_say_section.testimonials.sahin'
  },
  {
    id: '6',
    videoUrl: 'https://colochousing-production.s3.eu-west-1.amazonaws.com/Dogukan+.mp4',
    thumbnailUrl: dogukanThumbnail,
    title: 'js.features.marketplace.home.what_our_housemates_say_section.testimonials.dogukan'
  }
];
